import { observable, runInAction } from 'mobx'
import { getLogger } from './logger/logger.service'
import type { LogFunctions } from './logger/logger.types'

class OccService {
    private loggerValue: LogFunctions | undefined = undefined
    private get logger() {
        if (!this.loggerValue) {
            this.loggerValue = getLogger('OCC').value
        }
        return this.loggerValue
    }

    public overrideSiteIdObs = observable.box<string | undefined>(undefined)

    public setOverrideSiteId(siteId: string | undefined) {
        if (this.overrideSiteIdObs.get() === siteId) return

        setTimeout(() => {
            runInAction(() => {
                this.logger.debug('Setting site id to ' + siteId)

                this.overrideSiteIdObs.set(siteId)
            })
        }, 150)
    }

    public getOverrideSiteId = () => this.overrideSiteIdObs.get()

    private excludedMemberRewards: string[] | undefined = undefined

    public setExcludedMemberRewards(rewards: string[]) {
        this.excludedMemberRewards = rewards
    }

    public getExcludedMemberRewards = () => this.excludedMemberRewards
}

export const occService = new OccService()
